import { IPaymentType } from "../models/paymentType";

export const SET_PAYMENT_TYPES = "SET_PAYMENT_TYPES";

export const SetExaminationOrganizations = (payload: IPaymentType[]) => {
    return { type: SET_PAYMENT_TYPES, payload };
};